//init tesxts state with default strings
const state = () => ({
    employeesDetails: {
        tabTitle: 'Tickets',
        addButton: 'Add ticket',
        addFormTitle: 'Add new ticket',
    },
    ridesPassengetsList: { statusTitle: 'Ticket Status' },
    booking: { succeeded: 'Ticket created successfully' },
    confirmation: {
        markAsUsed: 'Are you sure you want to mark this ticket as used?',
        cancel: 'Are you sure you want to cancel this ticket?',
    },
    reports: {
        yaxisTitle: 'Booked Tickets',
        chartTitlePerRoute: 'Tickets by route',
        chartTitlePerEmployee: 'Tickets by employee',
        chartTitlePerDate: 'Tickets by date',
        chartTitlePerRatings: 'Employee ratings',
    },
    tooltips: { markAsUsed: 'Mark ticket as used', cancel: 'Cancel ticket' },
    sustainabilityReport: {
        numberOfTickets: 'Number of Tickets',
    },
});

const mutations = {
    setTexts(state: any, payload: any) {
        //replace text value if key exist in the payload - if not: stay as default
        Object.keys(payload).forEach((a) => {
            if (payload[a]) Object.assign(state[a], payload[a]);
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
